module.exports = {
  __depends__: [ require(41) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(32) ],
  elementRegistry: [ 'type', require(34) ],
  elementFactory: [ 'type', require(33) ],
  eventBus: [ 'type', require(35) ],
  graphicsFactory: [ 'type', require(36) ]
};